import initTop3 from './components/dynamic-security-systems/top-3';
import directoryFilterSort from './components/dynamic-filter-sort/';
import initalizeMap from './components/directoyMap';
import pagination from './components/dynamic-security-systems/pagination';
import SummaryHandler from './components/dynamic-security-systems/summary-handler';
import nearByCitiesTable from './components/dynamic-security-systems/nearby-cities-table';

// Initialize summary handlers for different components
// Both top-3 and listings will read their word limits from data attributes

// Top-3 summary handler
new SummaryHandler({
    selectors: {
        containers: '.security-card__desc',
        summary: '.desc',
        moreLink: '.desc-more',
        lessLink: '.desc-less',
    },
    mobileLineLimit: 3, // Mobile line limit only
});

// Listings summary handler
const listingsSummaryHandler = new SummaryHandler({
    selectors: {
        containers: '.listing-summary',
        summary: '.summary',
        moreLink: '.summary-more',
        lessLink: '.summary-less',
    },
    mobileLineLimit: 3, // Mobile line limit only
});

initTop3();
pagination();
directoryFilterSort();
initalizeMap();
nearByCitiesTable();

// Make it globally available for pagination
window.listingsSummaryHandler = listingsSummaryHandler;
